import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { Trash2 } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/Button';
import { ConfirmRemoveSliceModal } from '@/pages/MerchandisingCollections/components/ConfirmRemoveSliceModal';
import { SliceTags } from '@/pages/MerchandisingCollections/components/SliceTags';
import { MerchandisingCollectionSlice } from '@/services/MerchandisingCollectionsService';

interface MetaPanelProps {
  slice: MerchandisingCollectionSlice;
}

export function MetaPanel({ slice }: MetaPanelProps) {
  const [isConfirmRemoveModalOpen, setIsConfirmRemoveModalOpen] =
    useState(false);

  const { t } = useTranslation('translation', {
    keyPrefix:
      'pages.MerchandisingCollections.pages.Slice.components.SliceInfo',
  });

  return (
    <div className="space-y-4 border-t pt-4">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div className="space-y-1">
          <p className="text-xs text-muted-foreground">{t('createdAt')}</p>

          <p className="text-sm">
            {format(slice.createdAt, 'dd/MM/yyyy', {
              locale: ptBR,
            })}
          </p>
        </div>
        <div className="space-y-1">
          <p className="text-xs text-muted-foreground">{t('updatedAt')}</p>

          <p className="text-sm">
            {format(slice.updatedAt, 'dd/MM/yyyy', {
              locale: ptBR,
            })}
          </p>
        </div>
      </div>

      <SliceTags slice={slice} />

      <div className="pt-4">
        <Button
          type="button"
          variant="destructive"
          size="sm"
          onClick={() => setIsConfirmRemoveModalOpen(true)}
        >
          <Trash2 className="mr-2 h-4 w-4" />
          {t('removeButtonLabel')}
        </Button>
      </div>

      <ConfirmRemoveSliceModal
        sliceToRemove={isConfirmRemoveModalOpen ? slice : null}
        onRemove={() => setIsConfirmRemoveModalOpen(false)}
      />
    </div>
  );
}
